import { PlanContractType } from 'types/plan.types';
import { User } from 'types/user.types';

export const checkUserSubsContractType = (user: User): { hasUserFinanceSubs: boolean; hasUserRentalSubs: boolean } => {
  const hasUserRentalSubs = user?.subscriptions.some(
    subscription => subscription?.plan?.contractType === PlanContractType.Rent
  );

  const hasUserFinanceSubs = user?.subscriptions.some(
    subscription => subscription?.plan?.contractType === PlanContractType.Finance
  );

  return { hasUserFinanceSubs, hasUserRentalSubs };
};
